import { module } from 'modujs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);

        this.track = this.el.querySelector('[data-scroll-track]');
        this.overlay = this.el.querySelector('[data-opacity]');
        this.title = this.el.querySelector('[data-title]');
        this.logo = this.el.querySelector('[data-logo]');
    }

    init() {
        if (!this.track) return;

        const isMobile = window.innerWidth < 768;
        const totalWidth = this.track.scrollWidth - window.innerWidth;

        this.initContentAnimation();

        if (!isMobile) {
            this.initHorizontalScroll(totalWidth);
        }

        ScrollTrigger.refresh();
    }

    initContentAnimation() {
        this.contentTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: 'top top',
                end: '+=250',
                scrub: 1,
                invalidateOnRefresh: true
            }
        });

        if (this.overlay) {
            this.contentTimeline.to(this.overlay, {
                opacity: 0,
                ease: 'none',
                duration: 1
            }, 0);
        }

        if (this.title) {
            this.contentTimeline.to(this.title, {
                y: -40,
                opacity: 0,
                ease: 'none',
                duration: 1
            }, 0);
        }

        if (this.logo) {
            this.contentTimeline.to(this.logo, {
                y: 40,
                opacity: 0,
                ease: 'none',
                duration: 1
            }, 0);
        }
    }

    initHorizontalScroll(totalWidth) {
        this.horizontalTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: 'top top',
                end: () => `+=${totalWidth}`,
                scrub: 2,
                pin: true,
                anticipatePin: 1,
                invalidateOnRefresh: true
            }
        });

        this.horizontalTimeline.to(this.track, {
            x: -totalWidth,
            ease: 'none'
        });
    }

    destroy() {
        if (this.contentTimeline) this.contentTimeline.kill();
        if (this.horizontalTimeline) this.horizontalTimeline.kill();
    }
}